import React from 'react';
import {makeObservable, observable, computed} from "mobx";
import {observer} from 'mobx-react';
import Mousetrap from 'mousetrap';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import addModal from '../utils/state/react_modals';
import addContext from '../utils/state/context';
import trackProgress from '../utils/state/progress';
import {createAjaxErrorHandler} from "../utils/error_handling";
import fbq from '../utils/facebook_pixel';

const CartUpdatedDialog = observer(
    class CartUpdatedDialog extends React.Component {
      componentDidMount() {
        const mt = Mousetrap();

        this.context = addContext({
          register: () => {
          },
          unregister: () => {
            mt.reset();
          }
        });
      }

      componentWillUnmount() {
        this.context.remove();
      }

      render() {
        return (
          <div>
            <Modal isOpen={true} toggle={this.props.onClose}>
              <ModalBody>
                <div dangerouslySetInnerHTML={{__html: this.props.contents}}/>
                <div className="d-flex">
                  <button type="button" onClick={this.props.onClose} className="btn btn-primary btn-block btn-lg mr-1">
                    Continue
                  </button>
                  <a href="/store/cart/" onClick={this.props.onClose}
                     className="btn btn-outline-dark btn-block btn-lg mt-0 ml-1">
                    View Cart
                  </a>
                </div>
              </ModalBody>
            </Modal>
          </div>
        );
      }
    }
);

$(document.body).on('submit', 'form', event => {
  const form = event.target;
  if (form.getAttribute("action").match(/cart\.cgi|store\/add-to-cart\/|store\/addtocart\.aspx/i)) {
    event.preventDefault();

    fbq('track', 'AddToCart');

    trackProgress({
      name: 'Adding to cart...',
      modal: false,
      promise: $.ajax({
        method: 'post',
        url: '/store/add-to-cart/',
        data: $(form).serialize(),
      }).then(data => {
        addModal((close, confirm) => (
          <CartUpdatedDialog onClose={close} onSelect={confirm} contents={data.contents}/>
        ));
      }, createAjaxErrorHandler())
    });
  }
});

export default CartUpdatedDialog;
